import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

import { AddAllSectionLayer } from "../components/ImportQuestion/AddAllSectionLayer";

export const AddAllSectionPage = () => {
  return (
    <MasterLayout>
      <AddAllSectionLayer />
    </MasterLayout>
  );
};
